// extracted by mini-css-extract-plugin
export default {"text":"styles_text__id2Af","weare":"styles_weare__qApre","weare__cover":"styles_weare__cover__nhoeL"};